import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5efc3874"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "smartphoneModal",
  tabindex: "-1",
  "aria-labelledby": "smartphoneModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content bg-transparent shadow-none" }
const _hoisted_4 = { class: "modal-body smartphone" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle fs-6 gy-3 table-bordered" }
const _hoisted_10 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DrawComponent = _resolveComponent("DrawComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-icon-dark close-button",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearData && _ctx.clearData(...args)))
          }, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("tbody", null, [
                  (_ctx.formStructure.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formStructure, (row, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.columns, (col, colIndex) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: colIndex,
                              class: "border",
                              colspan: `${
                          (_ctx.MAX_BLOCKS / _ctx.spanInColumn[index]) * col.colSpan
                        }`
                            }, [
                              _createElementVNode("div", _mergeProps({ class: "d-flex align-items-center" }, row.rowProp, {
                                class: col.class,
                                style: {"column-gap":"2em"}
                              }), [
                                (col.components.length > 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(col.components, (component, compIndex) => {
                                      return (_openBlock(), _createBlock(_component_DrawComponent, {
                                        key: compIndex,
                                        component: component,
                                        isDraggable: false,
                                        isPreview: true
                                      }, null, 8, ["component"]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ], 16)
                            ], 8, _hoisted_10))
                          }), 128))
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}